import Vue from 'vue';
import { LoadingService } from '@/services';
import { EventBus } from '@/event-bus/index';
import { getContentArea } from '@/contentful';
import { s3Instance } from '@/services';
import { FileUtils } from '@/helpers';
import store from '@/store';

export default Vue.extend({
  methods: {
    openMatchToTransactionScreen(params) {
      const promises = [
        getContentArea([
          'match-document-to-transaction-success',
          'match-document-to-transaction-error',
        ]),
        this.$store.dispatch('getClaimData'),
      ];
      const IS_DISPLAYABLE = FileUtils.isDisplayable(params.document.fileName);

      if (IS_DISPLAYABLE) {
        const EXTENSION = FileUtils.getFilenameExtension(
          params.document.fileName,
        );
        const uuidExtension = FileUtils.getFilenameExtension(
          params.document.uuid,
        );
        if (!uuidExtension) {
          promises.push(
            s3Instance.getFile(
              FileUtils.concatFilename(params.document.uuid, EXTENSION),
            ),
          );
        } else if (uuidExtension) {
          promises.push(s3Instance.getFile(params.document.uuid));
        }
      }
      LoadingService.watchPromises(promises)
        .then((data) => {
          const CONTENT_AREAS = data[0];
          const CLAIM_DATA = store.getters.claimData;
          let paramsObj: any = {};

          if (CONTENT_AREAS) {
            if (CONTENT_AREAS[0] && CONTENT_AREAS[0].fields) {
              paramsObj.successMessage = CONTENT_AREAS[0].fields.content;
            }
            if (CONTENT_AREAS[1] && CONTENT_AREAS[1].fields) {
              paramsObj.errorMessage = CONTENT_AREAS[1].fields.content;
            }
          }
          paramsObj.file = data[2];
          paramsObj = Object.assign(paramsObj, params);

          if (CLAIM_DATA.length) {
            EventBus.$emit(
              'openOverlayWrapper',
              'MatchToTransaction',
              paramsObj,
            );
          } else {
            EventBus.$emit('openModal', 'Error', {
              title: 'match-to-transaction_error-no-claims-heading',
              message: 'match-to-transaction_error-no-claims-message',
            });
          }
        })
        .catch((error) => {
          EventBus.$emit('openModal', 'Error', {
            message: 'global_connection-error',
          });
        });
    },
  },
});
